<template>
  <div>
    <navbar></navbar>
    <!-- <div class="workspaceImage"></div> -->
    <div class="row ml-0 mr-0 w-100" style="margin-top: 50px">
      <img
        style="cursor: pointer"
        src="static/img/WorkspaceImage.png"
        class="w-100"
      />
    </div>
    <div
      class="row card borderless-card ml-0 mr-0"
      style="box-shadow: none; margin-top: 30px"
    >
      <div
        class="col-12"
        style="padding-left: 60px !important; padding-right: 50px !important"
      >
        <div
          class="row workspace-div"
          style="justify-content: space-between; margin: auto"
        >
          <div style="font-size: 20px; line-height: 25px">My Workspace</div>
          <!-- v-if="plan.length>0 && plan.toLocaleLowerCase() != 'free'" -->
          <div class="d-flex">
            <div style="margin-right: 15px" @click="navigateToProRata('buy')">
              <button class="newTask" style="height: 36px">
                Buy Positions
              </button>
            </div>
            <div style="margin-right: 15px" @click="navigateToProRata('sell')">
              <button class="newTask" style="height: 36px">
                Sell Positions
              </button>
            </div>
            <div>
              <button
                class="create-workspace-btn btn-primary"
                @click="handleCreate"
                v-if="showCreateWorkspaceButton"
              >
                Create Workspace
              </button>
            </div>
          </div>
        </div>
        <div v-if="myWorkspaces && myWorkspaces.length > 0">
          <div v-for="clientItem in myWorkspaces" :key="clientItem.clientId">
            <div class="d-flex" style="flex-wrap: wrap">
              <div
                class="wrapperWorkspaceDiv"
                v-for="item in clientItem.account_workspace"
                :key="item.workspace_id"
              >
                <!-- <div class=""> -->
                <div
                  :class="`${topWorkspaceDiv(
                    item.workspace_type,
                    'div'
                  )} d-flex`"
                >
                  <div class="imageDiv" @click="switchWorkspace(item)">
                    <b-avatar
                      :text="workspaceTitleText(item.workspace_title)"
                      rounded="sm"
                      :size="50"
                      variant="primary"
                      :style="styleWorkspaceAvatar(item.workspace_type)"
                      :src="avatarSrc(item)"
                      class="align-baseline"
                    ></b-avatar>
                  </div>
                  <div class="infoDiv">
                    <!-- @click="makeDefault(item)" -->
                    <div
                      class="infoTitle"
                      @click="switchWorkspace(item)"
                      :title="item.workspace_title"
                    >
                      {{ item.workspace_title }}
                    </div>
                    <div class="infoType">{{ item.workspace_type }}</div>
                  </div>
                  <div>
                    <b-dropdown
                      size="sm"
                      variant
                      right
                      :class="`company-card-dropdown ${topWorkspaceDiv(
                        item.workspace_type,
                        'button'
                      )}`"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template
                        v-slot:button-content
                        style="border: 0; background: #f5f5f5"
                      >
                        <i
                          class="fa fa-ellipsis-h"
                          aria-hidden="true"
                          style="color: #00000080"
                        ></i>
                      </template>
                      <b-dropdown-item @click="editWorkspace(item)"
                        >Edit</b-dropdown-item
                      >
                      <b-dropdown-item
                        @click="
                          confirmMdlShow = true;
                          deleteItem = item;
                          deleteType = 'my';
                        "
                        >Delete</b-dropdown-item
                      >
                      <b-dropdown-item @click="goToWorkspaceProfile(item)"
                        >Profile</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>
                <div class="row ml-0 mr-0 workspacePortfolioInfo">
                  <div class="col-4 pl-0 pr-0">
                    <div v-if="item.workspace_type != 'Limited Partner'">
                      <div class="workspaceItemHeaders">Portfolio Value</div>
                      <div class="workspaceItemInfoValue">
                        ${{ precisionNumberForamtter(item.portfolio_value, 1) }}
                      </div>
                    </div>
                    <div v-else>
                      <div class="workspaceItemHeaders">Fund Size</div>
                      <div class="workspaceItemInfoValue">
                        ${{
                          item.thesisData && item.thesisData.size
                            ? precisionNumberForamtter(item.thesisData.size, 1)
                            : 0
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="col-4 pl-0 pr-0">
                    <div v-if="item.workspace_type == 'General Partner'">
                      <div class="workspaceItemHeaders">Investments</div>
                      <div class="workspaceItemInfoValue">
                        {{ item.investCount }}
                      </div>
                    </div>
                    <div v-else-if="item.workspace_type == 'Limited Partner'">
                      <div class="workspaceItemHeaders">Value Of Portfolio</div>
                      <div class="workspaceItemInfoValue">
                        ${{
                          item.lpFundAdditionalData &&
                          item.lpFundAdditionalData.fund_value_of_portfolio
                            ? precisionNumberForamtter(
                                item.lpFundAdditionalData
                                  .fund_value_of_portfolio,
                                1
                              )
                            : 0
                        }}
                      </div>
                    </div>
                    <div v-else>
                      <div class="workspaceItemHeaders">Portfolio</div>
                      <div class="workspaceItemInfoValue">
                        {{ item.portfolio_length }}
                      </div>
                    </div>
                  </div>
                  <div class="col-4 pl-0 pr-0">
                    <div v-if="item.workspace_type == 'General Partner'">
                      <div class="workspaceItemHeaders">Exits</div>
                      <div class="workspaceItemInfoValue">{{ item.exits }}</div>
                    </div>
                    <div v-else-if="item.workspace_type == 'Limited Partner'">
                      <div class="workspaceItemHeaders">DPI</div>
                      <div class="workspaceItemInfoValue">
                        {{
                          item.lpFundAdditionalData &&
                          item.lpFundAdditionalData.fund_dpi
                            ? item.lpFundAdditionalData.fund_dpi
                            : 0
                        }}
                      </div>
                    </div>
                    <div v-else>
                      <div class="workspaceItemHeaders">Diligence</div>
                      <div class="workspaceItemInfoValue">
                        {{ item.diligence_length }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          You haven't created any workspaces. Create a workspace to manage your
          portfolio.
        </div>
        <div style="margin-top: 53px">
          <div
            style="font-size: 20px; line-height: 25px"
            v-if="sharedWorkspace && sharedWorkspace.length > 0"
          >
            Shared with me
          </div>
          <div v-for="clientItem in sharedWorkspace" :key="clientItem.clientId">
            <div class="clientNameCls">{{ clientItem.client_name }}</div>
            <div class="d-flex" style="flex-wrap: wrap">
              <div
                class="wrapperWorkspaceDiv"
                v-for="item in clientItem.account_workspace"
                :key="item.workspace_id"
              >
                <div
                  :class="`${topWorkspaceDiv(
                    item.workspace_type,
                    'div'
                  )} d-flex`"
                >
                  <div class="imageDiv" @click="switchWorkspace(item)">
                    <b-avatar
                      :text="workspaceTitleText(item.workspace_title)"
                      rounded="sm"
                      :size="50"
                      variant="primary"
                      :style="styleWorkspaceAvatar(item.workspace_type)"
                      :src="avatarSrc(item)"
                      class="align-baseline"
                    ></b-avatar>
                  </div>
                  <div class="infoDiv">
                    <!-- @click="makeDefault(item)" -->
                    <div
                      class="infoTitle"
                      @click="switchWorkspace(item)"
                      :title="item.workspace_title"
                    >
                      {{ item.workspace_title }}
                    </div>
                    <div class="infoType">{{ item.workspace_type }}</div>
                  </div>
                  <div>
                    <b-dropdown
                      size="sm"
                      variant
                      right
                      :class="`company-card-dropdown ${topWorkspaceDiv(
                        item.workspace_type,
                        'button'
                      )}`"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template
                        v-slot:button-content
                        style="border: 0; background: #f5f5f5"
                      >
                        <i
                          class="fa fa-ellipsis-h"
                          aria-hidden="true"
                          style="color: #00000080"
                        ></i>
                      </template>
                      <b-dropdown-item @click="editWorkspace(item)"
                        >Edit</b-dropdown-item
                      >
                      <b-dropdown-item
                        @click="
                          confirmMdlShow = true;
                          deleteItem = item;
                          deleteType = 'shared';
                        "
                        >Delete</b-dropdown-item
                      >
                      <b-dropdown-item @click="goToWorkspaceProfile(item)"
                        >Profile</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>
                <div class="row ml-0 mr-0 workspacePortfolioInfo">
                  <div class="col-4 pl-0 pr-0">
                    <div v-if="item.workspace_type != 'Limited Partner'">
                      <div class="workspaceItemHeaders">Portfolio Value</div>
                      <div class="workspaceItemInfoValue">
                        ${{ precisionNumberForamtter(item.portfolio_value, 1) }}
                      </div>
                    </div>
                    <div v-else>
                      <div class="workspaceItemHeaders">Fund Size</div>
                      <div class="workspaceItemInfoValue">
                        ${{
                          item.thesisData && item.thesisData.size
                            ? precisionNumberForamtter(item.thesisData.size, 1)
                            : 0
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="col-4 pl-0 pr-0">
                    <div v-if="item.workspace_type == 'General Partner'">
                      <div class="workspaceItemHeaders">Investments</div>
                      <div class="workspaceItemInfoValue">
                        {{ item.investCount }}
                      </div>
                    </div>
                    <div v-else-if="item.workspace_type == 'Limited Partner'">
                      <div class="workspaceItemHeaders">Value Of Portfolio</div>
                      <div class="workspaceItemInfoValue">
                        ${{
                          item.lpFundAdditionalData &&
                          item.lpFundAdditionalData.fund_value_of_portfolio
                            ? precisionNumberForamtter(
                                item.lpFundAdditionalData
                                  .fund_value_of_portfolio,
                                1
                              )
                            : 0
                        }}
                      </div>
                    </div>
                    <div v-else>
                      <div class="workspaceItemHeaders">Portfolio</div>
                      <div class="workspaceItemInfoValue">
                        {{ item.portfolio_length }}
                      </div>
                    </div>
                  </div>
                  <div class="col-4 pl-0 pr-0">
                    <div v-if="item.workspace_type == 'General Partner'">
                      <div class="workspaceItemHeaders">Exits</div>
                      <div class="workspaceItemInfoValue">{{ item.exits }}</div>
                    </div>
                    <div v-else-if="item.workspace_type == 'Limited Partner'">
                      <div class="workspaceItemHeaders">DPI</div>
                      <div class="workspaceItemInfoValue">
                        {{
                          item.lpFundAdditionalData &&
                          item.lpFundAdditionalData.fund_dpi
                            ? item.lpFundAdditionalData.fund_dpi
                            : 0
                        }}
                      </div>
                    </div>
                    <div v-else>
                      <div class="workspaceItemHeaders">Diligence</div>
                      <div class="workspaceItemInfoValue">
                        {{ item.diligence_length }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        left
        :title="workspaceTitle"
        :closeOnClickModal="false"
        :closeOnPressEscape="false"
        width="405px"
        style="margin: 0 auto"
        @close="handleCancel"
        :visible.sync="workspaceModalShow"
        class="team-modal workspace-modal col-lg-12 col-sm-12 col-12 col-md-12"
      >
        <form @submit.prevent="formSubmit">
          <div class="form-group">
            <div class="label">Workspace Title</div>
            <input
              type="text"
              required
              class="form-control team-form"
              placeholder="Workspace Title"
              v-model="workspaceForm.title"
            />
          </div>
          <div class="form-group">
            <div class="label">Workspace Type</div>
            <el-select
              class="todo-dropdown-el-select"
              size="large"
              required
              disabled
              placeholder="Select priority"
              v-model="workspaceForm.workspace_type"
            >
              <el-option
                v-for="option in vals.WORKSPACES"
                class="select-primary"
                :value="option"
                :label="option"
                :key="option"
              ></el-option>
            </el-select>
          </div>
          <div slot="footer" class="dialog-footer" style>
            <div
              style="
                border: 0.8px solid #ededed;
                opacity: 1;
                margin-top: 18px;
                display: none;
              "
            ></div>
            <div
              class="col-xl edit-company-action-button-row"
              style="padding: 0px; margin-top: 30px; margin-bottom: 30px"
            >
              <button
                type="button"
                class="todo-form-cancel-button btn-outline-secondary"
                @click="handleCancel"
              >
                Cancel
              </button>
              <button
                type="submit"
                class="todo-form-submit-button btn btn-primary"
                :disabled="isSaving || workspaceForm.title == ''"
              >
                Save
                <b-spinner
                  v-if="isSaving"
                  style="float: right"
                  small
                  label="Loading..."
                ></b-spinner>
              </button>
            </div>
          </div>
        </form>
      </el-dialog>
      <el-dialog
        center
        title="Really Delete?"
        :closeOnClickModal="false"
        :closeOnPressEscape="false"
        width="750px"
        style="margin: 0 auto"
        :visible.sync="confirmMdlShow"
        class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
      >
        <div class="card-body">
          <div class="inputs row">
            <p style="width: 100%; text-align: center">
              Are you sure you want to delete this item? This can't be undone.
            </p>
          </div>
          <div class="actionbuttons">
            <button
              @click.prevent="
                confirmMdlShow = !confirmMdlShow;
                deleteItem = {};
                isSaving = false;
              "
              class="todo-form-cancel-button btn-outline-secondary"
            >
              Cancel
            </button>
            <button
              class="todo-form-submit-button btn btn-primary"
              style="height: 35px"
              :disabled="isSaving"
              @click="deleteMethod"
            >
              Yes
              <b-spinner v-if="isSaving" small label="Spinning"></b-spinner>
            </button>
          </div>
        </div>
      </el-dialog>
    </div>
    <el-dialog
      left
      width="410px"
      title="Buy Positions"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      @close="handleCancelConfirmation"
      :showClose="true"
      :visible.sync="showConfirmationDialog"
      class="sellProrataConfirmation"
    >
      <div style="padding: 0px 15px 0px 15px">
        <div class="row w-100 ml-0 mr-0">
          <div style="word-break: break-word; padding-bottom: 30px">
            Although we are currently not providing this service it is coming
            soon!
            <br />
            We have collected your request and will reach out when we find
            something that might be a match for you.
            <br />
            <br />
            Thank you,
            <br />
            fiifi
          </div>
        </div>
        <div class="text-right">
          <button
            type="button"
            style="height: 35px"
            class="todo-form-submit-button btn btn-primary"
            @click="handleConfirm()"
            :disabled="showSpinner"
          >
            Confirm
            <b-spinner
              v-if="showSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  formatCurrency,
  vals,
  formatNumber,
  precisionNumberForamtter,
} from "./../../../util";
import { Dialog } from "element-ui";
import { Select, Option } from "element-ui";
import { mapGetters } from "vuex";
import api from "../../../axios_api";
import SwitchNotification from "../../../pages/Dashboard/Components/SwitchNotification";
import NavbarNew from "../Layout/NavbarNew";
import config from "../../../../config/settings";
export default {
  computed: {
    ...mapGetters("user", ["currency", "user"]),
    ...mapGetters("workspace", ["workspaces"]),
    ...mapGetters("accountPlans", ["plan"]),
    ...mapGetters("workspace", ["currentWorkspace"]),
    workspacesData() {
      let data = JSON.parse(JSON.stringify(this.workspaces));
      data = data.filter((item) => {
        if (item.clientName && item.clientName._id) return item;
      });
      let result = _.chain(data)
        .groupBy("clientName._id")
        .map(function (v, i) {
          return {
            clientId: i,
            client_name:
              v[0].clientName.firstName != v[0].clientName.lastName
                ? `${v[0].clientName.firstName} ${v[0].clientName.lastName}`
                : v[0].clientName.firstName,
            account_workspace: _.map(v),
          };
        })
        .value();
      result.map((item) => {
        if (item.account_workspace) {
          item.account_workspace.map((workspaceItem) => {
            workspaceItem.workspace_id = workspaceItem.workspace._id;
            workspaceItem.workspace_title = workspaceItem.workspace.title
              ? workspaceItem.workspace.title
              : "Untitled";
            workspaceItem.workspace_type = workspaceItem.workspace
              .workspace_type
              ? workspaceItem.workspace.workspace_type
              : "";
            workspaceItem.stages = workspaceItem.workspace.stages
              ? workspaceItem.workspace.stages
              : [];
            workspaceItem.sectors = workspaceItem.workspace.sectors
              ? workspaceItem.workspace.sectors
              : "";
          });
        }
      });
      //  console.log(result);
      return result;
    },
    myWorkspaces() {
      return this.workspacesData.filter(
        (item) => item.clientId == this.$route.params.account_id
      );
    },
    sharedWorkspace() {
      return this.workspacesData.filter(
        (item) => item.clientId != this.$route.params.account_id
      );
    },
    showCreateWorkspaceButton() {
      let feature = this.$store.getters["accountPlans/feature"];
      if (feature && feature.length > 0) {
        if (this.plan.length > 0 && this.plan.toLocaleLowerCase() != "free") {
          this.oldValue = true;
          return true;
        } else {
          this.oldValue = false;
          return false;
        }
      } else return this.oldValue;
    },
  },
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    [NavbarNew.name]: NavbarNew,
  },
  data() {
    return {
      vals,
      workspaceTitle: "",
      confirmMdlShow: false,
      workspaceModalShow: false,
      deleteItem: {},
      deleteType: "",
      workspaceForm: {},
      isSaving: false,
      oldValue: true,
      showWorkspaceProfile: false,
      showConfirmationDialog: false,
      showSpinner: false,
    };
  },
  methods: {
    formatCurrency: formatCurrency,
    precisionNumberForamtter: precisionNumberForamtter,
    styleWorkspaceAvatar(type) {
      if (type == "Direct Investment")
        return "background-color: #FFD562 !important;";
      else if (type == "General Partner")
        return "background-color: #78DE87 !important;";
      else return "background-color:#47B2FF !important;";
    },
    topWorkspaceDiv(type, item) {
      if (type == "Direct Investment" && item == "div")
        return "directWorkspaceDiv";
      else if (type == "General Partner" && item == "div")
        return "gpWorkspaceDiv";
      else if (type == "Limited Partner" && item == "div")
        return "lpWorkspaceDiv";
      else if (type == "Direct Investment" && item == "button")
        return "dropDown-direct-div";
      else if (type == "General Partner" && item == "button")
        return "dropDown-gp-div";
      else if (type == "Limited Partner" && item == "button")
        return "dropDown-lp-div";
    },
    makeDefault(item) {
      const self = this;
      let payload = {
        account_id: this.$route.params.account_id,
        workspace_id: item.workspace_id,
      };
      // this.$store
      //   .dispatch("workspace/apiDefaultWorkspace", payload)
      //   .then(res => {
      //     this.$store.commit("workspace/setDefaultPipeline", { payload: item });
      self.switchWorkspace(item);
      // })
      // .catch(err => {
      //   this.$toaster.error("Fail to update workspace information.", { err });
      // });
    },
    switchWorkspace(item) {
      this.$notifyClear();
      this.$notify({ component: SwitchNotification, timeout: 8000 });
      let userProfile = this.$store.getters["user/user"];
      let payload = {
        id: item.account,
        _id: item.account,
        workspace_id: item.workspace_id,
        image: userProfile.image ? userProfile.image : "",
        firstName: userProfile.firstName ? userProfile.firstName : "",
        lastName: userProfile.lastName ? userProfile.lastName : "",
        email: userProfile.email ? userProfile.email : "",
      };
      let fiifi = JSON.parse(localStorage.fiifi).user;
      if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
        if (item.workspace_id == fiifi.workspace_id) {
          let data = this.$store.getters["portfolio/portfolioData"];
          this.$notifyClear();
          if (data && data.length > 0) {
            let url =
              item &&
              item.hasOwnProperty("workspace_type") &&
              item.workspace_type == "Limited Partner"
                ? `/${payload._id}/${payload.workspace_id}/lpSummary`
                : `/${payload._id}/${payload.workspace_id}/dashboard/overview`;
            this.$router.push(url).catch((err) => {});
            return;
          } else {
            this.$router.push(
              `/${payload._id}/${payload.workspace_id}/portfolio`
            );
            return;
          }
        }
      }
      var defaultPayload = {
        workspace_title: item.workspace_title,
        workspace_type: item.workspace_type,
        workspace_id: item.workspace_id,
        sectors: item.sectors,
        stages: item.stages,
        targetCapitalToDeployPercent: item.targetCapitalToDeployPercent,
        feeAndExpenseLoadAssumptionPercent:
          item.feeAndExpenseLoadAssumptionPercent,
      };
      
      this.$store.commit("workspace/setDefaultPipeline", {
        payload: defaultPayload,
      });
      this.$store.commit("user/workspace_id", {
        workspace_id: item.workspace_id,
      });
      this.$store
        .dispatch("workspacePlans/getWorkspacePlanFeatures", {
          workspace_id: item.workspace_id,
        })
        .then((plans) => {
          this.$store.dispatch("arbiter/start");
          this.$store
            .dispatch("dashboardCoordinates/apiFetchCoordinates")
            .then((coordinates) => {
              this.$store
                .dispatch("portfolio/apiFetchPortfolio")
                .then((data) => {
                  if (data && data.length > 0) {
                    let url =
                      item &&
                      item.hasOwnProperty("workspace_type") &&
                      item.workspace_type == "Limited Partner"
                        ? `/${payload._id}/${payload.workspace_id}/lpSummary`
                        : `/${payload._id}/${payload.workspace_id}/dashboard/overview`;
                    this.$router.push(url).catch((err) => {});
                  } else {
                    this.$notifyClear();
                    this.$router.push(
                      `/${payload._id}/${payload.workspace_id}/portfolio`
                    );
                  }
                });
            });
        });
    },
    workspaceTitleText(title) {
      let text = title.split(" ");
      text =
        text.length > 1
          ? `${text[0].charAt(0)}${text[1].charAt(0)}`
          : text[0].charAt(0);

      return text;
    },
    handleCreate() {
      this.$router.push(`/${this.$route.params.account_id}/create/workspace`);
      // this.workspaceModalShow = true;
      // this.workspaceTitle = "Create Workspace";
      // this.workspaceForm.workspace_type = " Direct Investment";
    },
    deleteMethod() {
      let payload = {
        _id: this.deleteItem._id,
        account_id: this.$route.params.account_id,
        workspace_id: this.deleteItem.workspace_id,
        type: this.deleteType,
        s3Key:
          this.deleteItem.hasOwnProperty("workspace") &&
          this.deleteItem.workspace.hasOwnProperty("s3Key") &&
          this.deleteItem.workspace.s3Key.length > 0
            ? this.deleteItem.workspace.s3Key
            : "",
      };
      let self = this;
      this.isSaving = true;
      this.$store
        .dispatch("workspace/apiDeleteWorkspace", payload)
        .then((res) => {
          this.confirmMdlShow = false;
          this.isSaving = false;
          this.deleteItem = {};
          this.deleteType = "";
          this.$store.dispatch("notifications/start");
          this.$toaster.success(
            "Successfully removed your data from the server!"
          );
          if (this.myWorkspaces.length == 0 && this.sharedWorkspace == 0) {
            this.createDefaultWorkspace();
          }
        })
        .catch((err) => {
          this.isSaving = false;
          this.$toaster.error("Fail to delete the workspace");
        });
    },
    editWorkspace(item) {
      if (item.workspace_type == "Limited Partner") {
        var defaultPayload = {
          workspace_title: item.workspace_title,
          workspace_type: item.workspace_type,
          workspace_id: item.workspace_id,
          sectors: item.sectors,
          stages: item.stages,
          targetCapitalToDeployPercent: item.targetCapitalToDeployPercent,
        feeAndExpenseLoadAssumptionPercent:
          item.feeAndExpenseLoadAssumptionPercent,
        };
        this.$store.commit("workspace/setDefaultPipeline", {
          payload: defaultPayload,
        });
        this.$store.commit("user/workspace_id", {
          workspace_id: item.workspace_id,
        });
        this.$store.dispatch("lpAllocations/start");
        this.$router.push(
          `/${this.$route.params.account_id}/${item.workspace_id}/edit/workspace`
        );
      } else {
        this.workspaceTitle = "Edit Workspace";
        this.workspaceForm._id = item.workspace_id;
        this.workspaceForm.title = item.workspace_title;
        this.workspaceForm.workspace_type = item.workspace_type;
        this.workspaceModalShow = true;
      }
    },
    formSubmit() {
      this.isSaving = true;
      this.workspaceForm.title = this.workspaceForm.title.trim();
      if (this.workspaceForm.title.length <= 0) {
        this.$toaster.error("Please provide valid Workspace title");
        this.isSaving = false;
        return;
      }
      let self = this;
      if (this.workspaceTitle == "Edit Workspace" && this.workspaceForm._id) {
        this.$store
          .dispatch("workspace/apiPatchworkspacesInst", this.workspaceForm)
          .then((user) => {
            if (self.currentWorkspace.workspace_id == self.workspaceForm._id) {
              let payload = {};
              payload.workspace_id = this.workspaceForm._id;
              payload.workspace_title = this.workspaceForm.title;
              payload.workspace_type = this.workspaceForm.workspace_type;
              self.$store.commit("workspace/setDefaultPipeline", {
                payload: payload,
              });
            }
            self.handleCancel();
            this.$toaster.success("Saved Successfully.");
          })
          .catch((err) => {
            this.email = "";
            this.isSaving = false;
            this.$toaster.error("Fail to save the workspace.");
          });
      } else {
        this.$store
          .dispatch("workspace/apiPostworkspacesInst", this.workspaceForm)
          .then((user) => {
            self.handleCancel();
            this.$toaster.success("Saved Successfully.");
          })
          .catch((err) => {
            this.email = "";
            this.isSaving = false;
            this.$toaster.error("Fail to save the workspace.");
          });
      }
    },
    handleCancel() {
      this.workspaceForm = {};
      this.isSaving = false;
      this.workspaceModalShow = false;
    },
    createDefaultWorkspace() {
      let payload = {
        title: "Untitled",
        workspace_type: "Direct Investment",
      };
      this.$store
        .dispatch("workspace/apiDefaultCreateWorkspace", payload)
        .then((user) => {
          if (user) {
            let defaultPayload = {};
            defaultPayload._id = this.$route.params.account_id;
            defaultPayload.workspace_id = user.workspace;
            defaultPayload.workspace_title = "Untitled";
            defaultPayload.workspace_type = "Direct Investment";
            this.$store.commit("workspace/setDefaultPipeline", {
              payload: defaultPayload,
            });
            this.$store.commit("user/workspace_id", {
              workspace_id: defaultPayload.workspace_id,
            });
            this.$store.dispatch("arbiter/start");
            this.$store
              .dispatch("dashboardCoordinates/apiFetchCoordinates")
              .then((coordinates) => {
                this.$router.push(
                  `/${defaultPayload._id}/${defaultPayload.workspace_id}/portfolio`
                );
              });
          }
        })
        .catch((err) => {
          this.email = "";
          this.isSaving = false;
          this.$toaster.error("Fail to save the workspace.");
        });
    },
    goToWorkspaceProfile(item) {
      this.showWorkspaceProfile = true;
      if (item && item.workspace_id) {
        this.$store.commit("workspace/setCurrentWorkspaceProfile", item);
        this.$router.push(
          `/${this.$route.params.account_id}/workspace/profile`
        );
      }
    },
    avatarSrc(item) {
      let logo = "";
      if (
        item &&
        item.hasOwnProperty("workspace") &&
        item.workspace.hasOwnProperty("logo") &&
        item.workspace.logo.length > 0
      ) {
        logo = item.workspace.logo;
      }
      return logo;
    },
    navigateToProRata(context) {
      if (context == "sell") {
        this.$router.push(
          `/${this.$route.params.account_id}/${context}/prorata`
        );
      } else {
        this.showConfirmationDialog = true;
      }
    },
    handleCancelConfirmation() {
      this.showSpinner = false;
      this.showConfirmationDialog = false;
    },
    handleConfirm() {
      this.showSpinner = true;
      api
        .post("/generic/send/email", {
          encrypt: {
            data: {
              emails: config.DEAL_ROOM_EMAILS,
              subject: `Buy Positions - ${config.ENVIRONMENT}`,
              body: `Hi,\n ${this.user.firstName} ${this.user.lastName || ""}(${
                this.user.email
              }) with account_id:${
                this.$route.params.account_id
              } is interested in buying Pro rata with the help of Fiifi.`,
            },
          },
        })
        .then((data) => {
          this.handleCancelConfirmation();
          this.$toaster.success("Email Sent Successfully");
        })
        .catch((error) => {
          console.log("error in sending email", error);
          this.$toaster.error("Failed to send!!!");
        });
    },
  },
  mounted() {
    this.$store.dispatch("workspace/apiFetchworkspaces");
    const titleEl = document.querySelector("head title");
    titleEl.textContent = `Fiifi | Workspace`;
  },
};
</script>
<style>
.workspace-btn {
  background: #5445f3 0% 0% no-repeat padding-box;
  border-radius: 4px;
  height: 36px;
}

.workspace-div {
  padding-top: 30px;
  padding-bottom: 20px;
}

.workspace-modal .el-dialog .el-dialog__header {
  padding: 30px 20px 10px;
}

.workspaceItemDiv {
  width: 310px;
  height: 80px;
  /* background: #f5f5f5 0% 0% no-repeat padding-box; */
  border-radius: 4px;
  margin-right: 12px;
  margin-bottom: 12px;
}

.imageDiv {
  padding-right: 15px;
  padding-top: 15px;
  padding-left: 15px;
  cursor: pointer !important;
}
.infoDiv {
  padding-top: 16px;
  width: 190px;
}

.infoType {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
}

.dropDown-direct-div .btn {
  background-color: #fff8e6;
  border: none;
}

.dropDown-gp-div .btn {
  background-color: #f2fff4;
  border: none;
}
.dropDown-lp-div .btn {
  background-color: #e6f4ff;
  border: none;
}
.create-workspace-btn {
  height: 35px;
  color: #ffffff;
  background-color: #5445f3 !important;
  font-size: 14px;
  line-height: 12px;
  font-family: "custom-helvetica-medium", "roboto";
  border-radius: 0.25rem;
  display: inline-block;
  padding: 8px 16px;
}

.directWorkspaceDiv {
  background: #fff8e6 0% 0% no-repeat padding-box;
  padding-bottom: 15px;
}

.gpWorkspaceDiv {
  background: #f2fff4 0% 0% no-repeat padding-box;
  padding-bottom: 15px;
}

.lpWorkspaceDiv {
  background: #e6f4ff 0% 0% no-repeat padding-box;
  padding-bottom: 15px;
}
.workspaceItemHeaders {
  color: #00000084;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 4px;
}

.wrapperWorkspaceDiv {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0 3px 6px rgb(0 0 0 / 0.1);
  border-radius: 4px;
  width: 310px;
  border-radius: 4px;
  margin-right: 30px;
  margin-bottom: 30px;
}

.workspacePortfolioInfo {
  text-align: center;
  padding-top: 15px;
  padding-bottom: 15px;
}
.workspaceImage {
  background-image: url("../../../../public/static/img/WorkspaceImage.png");
  background-size: cover;
  height: auto;
  min-height: 270px;
  margin-top: 50px;
}

.imageDiv .b-avatar .b-avatar-text {
  color: #000000 !important;
}
</style>